var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10 18a8 8 0 1 0 0-16.001A8 8 0 0 0 10 18m0-18a10 10 0 1 1 0 20C4.47 20 0 15.5 0 10A10 10 0 0 1 10 0m.5 5v5.25l4.5 2.67-.75 1.23L9 11V5z"
})));
export default SvgClock;